import { FC, ReactElement } from 'react'

import './UserColor.scss'

interface UserColorProps {
    color?: string
    className?: string
}

export const UserColor: FC<UserColorProps> = ({ color, className = '' }): ReactElement => (
    <div
        className={`user-color ${className}`}
        style={color ? { background: `#${color}` } : {}}
    />
)
